import React from "react";
import { Box, Typography, CardContent } from "@mui/material";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { StudentStatsDto } from "../../../shared/dtos/student/StudentStatsDto";
import { TeacherStatsDto } from "../../../shared/dtos/teacher/TeacherStatsDto";

const COLORS = ["#1976d2", "#e91e63"];

interface GenderPieChartWidgetProps {
  entityName: string;
  data: StudentStatsDto | TeacherStatsDto;
}

const GenderPieChartWidget: React.FC<GenderPieChartWidgetProps> = ({
  entityName,
  data,
}) => {
  const meta = getEntityMeta(entityName);
  const Icon = meta.icon;

  const chartData = [
    { name: "Male", value: data.male },
    { name: "Female", value: data.female },
  ];

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total: {data.total}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ height: 220, width: "100%" }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={chartData}
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
              >
                {chartData.map((_entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={COLORS[index % COLORS.length]}
                  />
                ))}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" height={36} />
            </PieChart>
          </ResponsiveContainer>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default GenderPieChartWidget;
